import React, { useState } from 'react'
import "./Nosotros.css"
import { Contacto } from '../Contacto/Contacto'
import { Link } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome' 
import { faChevronDown } from '@fortawesome/free-solid-svg-icons'

export const Nosotros = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  // Función para manejar la apertura y cierre de cada pregunta
  const handleToggle = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="div-nosotros">
      <img className='img-nosotros' src="/imgs/ropa.jpg" alt="ropa en perchas" />
      <div className="div-texto">
        <h1>Sobre Nosotros</h1>

        <div className="about-section">
          <h2>Sumergete en la Nueva Era de la Moda de Segunda Mano</h2>

          <p>En eRastro no solo reunimos las mejores prendas de segunda mano de múltiples tiendas online en un solo lugar, transformamos tu experiencia de compra gracias a nuestro innovador modelo de inteligencia artificial, sistema de alertas personalizadas y rastreo inteligente de productos.</p>

          <p>Ahorra tiempo y dinero accediendo de forma automática a las mejores oportunidades del mercado antes que nadie. Nuestra tecnología te permite descubrir productos únicos al mejor precio, justo cuando aparecen, sin tener que buscarlos tú mismo.</p>

          <p>Con eRastro no solo compras moda sostenible con estilo, también accedes a información privilegiada que te da ventaja. Compra de forma más inteligente, consciente y eficiente.</p>

          <p>¡Bienvenido a eRastro, donde la tecnología y la moda se unen para ayudarte a ahorrar, destacar y cuidar el planeta!</p>
        </div>


        {/* Sección de Q&A */}
        <div className="faq-section">
          <h2>Preguntas Frecuentes (Q&A)</h2>

          {/* Pregunta 1 */}
          <div className="faq-item">
            <button className="faq-question" onClick={() => handleToggle(0)}>
              ¿Qué es eRastro?
              <span className={`faq-arrow ${activeIndex === 0 ? 'open' : ''}`}><FontAwesomeIcon icon={faChevronDown} /></span>
            </button>
            {activeIndex === 0 && (
              <div className="faq-answer">
                <p>eRastro es mucho más que un buscador: es una plataforma inteligente que centraliza productos de tiendas de segunda mano como Vinted, Wallapop y eBay, y utiliza inteligencia artificial para ayudarte a encontrar lo que realmente buscas, sin perder tiempo.</p>
                
                <p>Con nuestros filtros avanzados, buscador por texto y sistema de alertas personalizadas, puedes rastrear automáticamente productos específicos y recibir notificaciones en cuanto aparezcan.</p>
                
                <p>Rastrea productos, activa tus alertas y deja que eRastro trabaje por ti. Ahorra dinero, accede a oportunidades únicas y consigue más con menos esfuerzo.</p>
              </div>

            )}
          </div>

          {/* Pregunta 2 */}
          <div className="faq-item">
            <button className="faq-question" onClick={() => handleToggle(1)}>
              ¿En eRastro se pueden comprar productos?
              <span className={`faq-arrow ${activeIndex === 1 ? 'open' : ''}`}><FontAwesomeIcon icon={faChevronDown} /></span>
            </button>
            {activeIndex === 1 && (
              <div className="faq-answer">
                <p>No, eRastro no vende productos directamente. Recopilamos productos de tiendas de segunda mano para ayudarte a encontrar lo que necesitas de forma rápida y sencilla. Las compras se realizan directamente en las tiendas de segunda mano.</p>
              </div>
            )}
          </div>

          {/* Pregunta 3 */}
          <div className="faq-item">
            <button className="faq-question" onClick={() => handleToggle(2)}>
              ¿Cómo funcionan las alertas?
              <span className={`faq-arrow ${activeIndex === 2 ? 'open' : ''}`}><FontAwesomeIcon icon={faChevronDown} /></span>
            </button>
            {activeIndex === 2 && (
              <div className="faq-answer">
                <p>Las alertas te notifican cuando una prenda que cumple con tus criterios está disponible. Configura tus alertas indicando detalles como talla, tipo de prenda o estado. Cuando entre un producto nuevo en nuestro sistema y haya coincidencias, recibirás un correo en tu email registrado.</p>
                <p>Si no recibes notificaciones, te recomendamos usar criterios más generales o revisar tu carpeta de spam. También puedes consultar en el apartado de alertas los productos que cumplieron con tus requisitos en la última semana.</p>
              </div>
            )}
          </div>

          {/* Pregunta 4 */}
          <div className="faq-item">
            <button className="faq-question" onClick={() => handleToggle(3)}>
              ¿Cómo puedo gestionar mi suscripción?
              <span className={`faq-arrow ${activeIndex === 3 ? 'open' : ''}`}><FontAwesomeIcon icon={faChevronDown} /></span>
            </button>
            {activeIndex === 3 && (
              <div className="faq-answer">
                <p>Puedes suscribirte a cualquiera de nuestros planes y cambiar entre ellos cuando desees. Si decides cancelar, tu suscripción permanecerá activa hasta el final del periodo ya pagado, pero no se renovará.</p>
              </div>
            )}
          </div>

          {/* Pregunta 5 */}
          <div className="faq-item">
            <button className="faq-question" onClick={() => handleToggle(4)}>
              ¿Qué pasa si borro mi cuenta?
              <span className={`faq-arrow ${activeIndex === 4 ? 'open' : ''}`}><FontAwesomeIcon icon={faChevronDown} /></span>
            </button>
            {activeIndex === 4 && (
              <div className="faq-answer">
                <p>Al borrar tu cuenta, se eliminará tu usuario y se cancelarán automáticamente todas las suscripciones activas. Ten en cuenta que esta acción es irreversible.</p>
              </div>
            )}
          </div>
          {/* Pregunta 6 */}
          <div className="faq-item">
            <button className="faq-question" onClick={() => handleToggle(5)}>
              ¿Cómo funciona el rastreador de productos?
              <span className={`faq-arrow ${activeIndex === 5 ? 'open' : ''}`}><FontAwesomeIcon icon={faChevronDown} /></span>
            </button>
            {activeIndex === 5 && (
              <div className="faq-answer">
                <p>Selecciona los productos que te interesan y agrégalos al Rastreador de productos. A partir de ese momento, nuestro sistema los monitorea automáticamente todos los días para detectar cualquier cambio de precio.</p>
                
                <p>Cuando se detecta una bajada, te enviamos una notificación inmediata para que aproveches la oportunidad y compres al mejor precio posible. Así, nunca se te escapará una buena oferta.</p>
              </div>

            )}
          </div>
        </div>
        <div>
          <button><a className="tutorial-boton" href="https://youtu.be/6dEWsX0FZIw" target='blank'>Ver Tutorial de uso la web</a></button>
        </div>
        <div>
          <Contacto />
        </div>
        <div className='paginas-legales'>
          <Link to="/aviso-legal">Aviso legal</Link>
          <Link to="/politica-cookies">Política de Cookies</Link>
          <Link to="/politica-privacidad">Política de Privacidad</Link>
        </div>
      </div>
    </div>
  )
}
